"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQQZS = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var maintab_1 = require("./shared/maintab");
var quotetable_1 = require("../quotetable");
/**
 * 全球指数-子类列表
 * @returns
 */
function PageQQZS() {
    return (react_1.default.createElement("div", { className: "pageqqzs" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefresh, null),
        react_1.default.createElement(maintab_1.MainTab2, null),
        react_1.default.createElement(quotetable_1.QuoteTable, null)));
}
exports.PageQQZS = PageQQZS;
